import moment from "moment";
import React from "react";
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchImmunizationResultsThunk, fetchLabResultsThunk, receiveLabResults, setSelectedUser } from '../actions/api';
import { doAddAccessThunk, setIsAddingAccess } from '../actions/auth';
import user from '../images/ic_account_circle.png';
import { formatDateOfBirth } from '../util/util';

//UserDependentBanner currently keeps the dependent's results. Depending on how the api is implmented, this will need to change.
//The UserDependentBanner keeps a copy of the dependent, and sets the labResults to be the one that correlate with that user. 
//We may need only keep track of the user's name and id here. 
class UserDependentBanner extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            user: props.user,
            index: props.index,
            language: props.language,
        }
    }

    doAddAccess=()=>{
        if(this.props.isAddingAccess !== true){
            this.props.dispatch(setIsAddingAccess(true));
            ReactGA.pageview('/logout');
            this.props.dispatch(doAddAccessThunk());
        }
    }

    render=()=>{
        let btn = <button className="btn btn-success btn-block" onClick={this.doGetResults}>{this.props.strings.VIEW_RESULTS}</button>;
        let vaccBtn = <button className="btn vacc-btn btn-block" onClick={this.getImmuneRecord}>{this.props.strings.IMMUNIZATION_RECORD}</button>;
        let checkValidDependant = !this.isAgeUnder16() && this.props.signedInUser.id !== this.state.user.id;
        // need to check if vaccination record exists
        let errorText = null;
        if (checkValidDependant) {
            btn = <button className="btn btn-secondary disabled btn-block">{this.props.strings.VIEW_RESULTS}<a></a></button>;
            vaccBtn = <button className="btn btn-secondary disabled btn-block">{this.props.strings.IMMUNIZATION_RECORD}</button>
            errorText = <div className="invalid-dependant-error mt-4">{this.props.strings.INVALID_DEPENDANT_ERROR}</div>
        }

        if (this.props.user.accessLevel === "1") {
            // IAL 1 user does not have access to vaccination stuff
            vaccBtn = null;
            btn = null;
        }

        return (
            <div className="user-banner">
                <div className="container mt-0">
                    <div className="row">
                        <div className="col-2 col-sm-1 mx-0 px-0">
                            <div className="userIcon"><img src={user} width="40" /></div>
                        </div>
                        <div className="col-10 col-sm-5 mx-0">
                            <h5 className="mb-0">{this.state.user.firstName + " " + this.state.user.lastName}</h5>
                            <p className="mb-1">{formatDateOfBirth(this.state.user.dateOfBirth, this.state.language)}</p>
                            <div className="med">{this.props.strings.MEDICARE}</div>
                            <div className="medNumber"><b>{this.props.strings.HCN_ISSUER[this.state.user.hcnIssuer] + " " + this.state.user.medicareNumber}</b></div>
                        </div>
                        <div className="col-12 col-sm-6 mt-md-0 mx-0 px-0">
                            <div className="float-none float-md-right mt-md-0">
                                <div className="container-fluid px-0">
                                    <div className="row-fluid justify-content-start mb-2">
                                        {btn}
                                    </div>
                                    <div className="row-fluid justify-content-start mb-2">
                                        {vaccBtn}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="error-text">{errorText}</div>
                    </div>
                </div>
            </div>
        );
    }

    doGetResults=() => {
        this.props.dispatch(setSelectedUser(this.state.user));
        // this.props.dispatch(receiveLabResults(this.state.results));
        let userId = null;
        if(this.state.user.isDependent){
            userId=this.state.user.id;
        }

        //TODO NEED to load page first before pushing to results or load on next page with spinner
        if(this.props.isFakeLoggedIn === false || this.props.isFakeLoggedIn===undefined || this.props.isFakeLoggedIn === null){
            this.props.dispatch(fetchLabResultsThunk(userId));
        }
        else{
            this.props.dispatch(receiveLabResults(this.state.results));
        }
        this.props.history.push("/results");
    }

    getImmuneRecord=() => {
        this.props.dispatch(setSelectedUser(this.state.user));
        let userId = null;
        if(this.state.user.isDependent){
            userId=this.state.user.id;
        }

        if(this.props.isFakeLoggedIn === false || this.props.isFakeLoggedIn===undefined || this.props.isFakeLoggedIn === null){
            this.props.dispatch(fetchImmunizationResultsThunk(userId));
        }
        else{
            this.props.dispatch(receiveLabResults(this.state.results));
        }
        this.props.history.push("/immunizations");
    }

    isAgeUnder16=()=>{
        let birthyear = Number(this.state.user.dateOfBirth.substring(0, 4));
        let birthmonth = Number(this.state.user.dateOfBirth.substring(5,7));
        let birthdate = Number(this.state.user.dateOfBirth.substring(8,10));
        let currentDate = moment();
        birthyear+=16;
        let sixteenthBirthdate = moment(""+birthyear+"-"+birthmonth+"-"+birthdate+"","YYYY-MM-DD");
        if(currentDate.isSameOrAfter(sixteenthBirthdate,'day')){
            return false;
        }
        else{
            return true;
        }
    }


}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        signedInUser: state.api.user,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isAddingAccess: state.auth.isAddingAccess,
    }
}

const ConnectedUserDependentBanner = connect(
    mapStateToProps
)(UserDependentBanner);
export default withRouter(ConnectedUserDependentBanner);
